import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'oval', 'Oval', [["path",{"d":"M6 12a6 9 0 1 0 12 0a6 9 0 1 0 -12 0","key":"svg-0"}]]);